import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'
import { resetState } from './state'
import { getters } from './getters'
import { createActions } from './actions'

export const useNotificationsStore = defineStore('notifications', () => {
  const state = reactive(resetState())

  // Getters
  const notifications = computed(() => state.notifications)
  const isLoading = computed(() => state.isLoading)
  const error = computed(() => state.error)
  const unreadCount = computed(() => getters.unreadCount(state))
  const hasUnread = computed(() => getters.hasUnread(state))
  const unreadNotifications = computed(() => getters.unreadNotifications(state))
  const readNotifications = computed(() => getters.readNotifications(state))
  const groupedNotifications = computed(() => getters.groupedNotifications(state))

  // Actions
  const actions = createActions(state)

  const $reset = () => {
    actions.cleanup()
    Object.assign(state, resetState())
  }

  return {
    // State (as computed for reactivity)
    notifications,
    isLoading,
    error,

    // Getters
    unreadCount,
    hasUnread,
    unreadNotifications,
    readNotifications,
    groupedNotifications,

    // Actions
    ...actions,

    // Reset
    $reset,
  }
})

export type NotificationsStore = ReturnType<typeof useNotificationsStore>
